// extracted by mini-css-extract-plugin
module.exports = {"button":"button-3dt6w","edit-icon":"edit-icon-39DAb","editIcon":"edit-icon-39DAb","label":"label-12dcM"};